import { jsxs, jsx } from 'react/jsx-runtime';

const SvgAlertCircle = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z" }), jsx("path", { fill: "#2D2E2E", d: "M13 7h-2v6h2V7ZM12 17.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })] }));

export { SvgAlertCircle as default };
//# sourceMappingURL=AlertCircle.es.js.map
